import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectTenant } from '../store/slices/authSlice'

/**
 * Hook para navegación con prefijo de tenant.
 * Uso: const navigate = useTenantNavigate()
 *      navigate('/dashboard') → /<slug>/dashboard
 */
const useTenantNavigate = () => {
  const navigate = useNavigate()
  const tenant = useSelector(selectTenant)
  const basePath = tenant?.slug ? `/${tenant.slug}` : ''

  return useCallback(
    (path, options) => {
      // Si el path ya tiene el slug prefix, navegar directamente
      if (path.startsWith(basePath + '/') || path === basePath) {
        navigate(path, options)
      } else {
        navigate(`${basePath}${path}`, options)
      }
    },
    [navigate, basePath]
  )
}

export default useTenantNavigate
